import { SgConnectEnvironment } from 'services/SgConnect/sgConnectEnvironment';

export enum Environment {
    Local = 'Local',
    Development = 'Development',
    Homologation = 'Homologation',
    Production = 'Production',
    Test = 'Test',
}

export const getEnvironment = () => {
    let environment = Environment.Production;

    if (typeof window === 'undefined' || !window.location.hostname) {
        environment = Environment.Test;
    } else if (window.location.hostname === 'local.fr.world.socgen'
        || window.location.hostname === 'localhost') {
        environment = Environment.Local;
    } else if (window.location.hostname === 'legal-dev.sgmarkets.com'
        || window.location.hostname === 'sgm-legal-dev.azureedge.net') {
        environment = Environment.Development;
    } else if (window.location.hostname === 'legal-uat.sgmarkets.com'
        || window.location.hostname === 'sgm-legal-uat.azureedge.net') {
        environment = Environment.Homologation;
    } else if (window.location.hostname === 'legal.sgmarkets.com'
        || window.location.hostname === 'sgm-legal-prd.azureedge.net'
        || window.location.hostname === 'legal-preview.sgmarkets.com'
        || window.location.hostname === 'sgm-legal-preview.azureedge.net') {
        environment = Environment.Production;
    }

    return environment;
};

interface IConfiguration {
    baseApiUrls: {
        legal: string;
    };
    authorizationEndpoint: string;
    clientId: string;
    scope: string;
    sgConnectEnvironment: SgConnectEnvironment;
    widgetCdnBaseUrl: string;
    sharedSgMarketsBaseUrl: string;
    sgMonitoringRumUrl: string;
    sgMarketsUrl: string;
    returnUrlDomainWhiteList: string[];
}

const defaultConfiguration = {
    baseApiUrls: {
        //legal: 'https://sgmarkets-api-legal-public-dev.sgmpinsight.dev.euw.gbis.sg-azure.com',
        legal: 'https://localhost:1307',
    },
    clientId: 'a1495f75-ea61-4c82-8ec4-d512ff12c41c',
    authorizationEndpoint: 'https://sgconnect-hom.fr.world.socgen/sgconnect',
    scope: [
        'mail',
        'openid',
        'profile',
    ].join(' '),
    sgConnectEnvironment: SgConnectEnvironment.Homologation,
    widgetCdnBaseUrl: 'https://sgwt-widgets-dev.sgmarkets.com',
    sharedSgMarketsBaseUrl: 'https://shared-uat.sgmarkets.com',
    sgMonitoringRumUrl: 'https://insight-realm-apm-hom.fleet.uat.sgmonitoring.dev.euw.gbis.sg-azure.com',
    sgMarketsUrl: 'https://www-dev.sgmarkets.com',
    returnUrlDomainWhiteList: [
        'sgmarkets.com',
        'socgen',
    ],
};

export const configurationPerEnvironment: Record<Environment, IConfiguration> = {
    [Environment.Local]: {
        ...defaultConfiguration,
    },
    [Environment.Development]: {
        ...defaultConfiguration,
        baseApiUrls: {
            legal: 'https://sgmarkets-api-legal-public-dev.sgmpinsight.dev.euw.gbis.sg-azure.com',
        },
    },
    [Environment.Homologation]: {
        ...defaultConfiguration,
        baseApiUrls: {
            legal: 'https://api-z-dev.sgmarkets.com/services/legal/anonymous/private/v1',
        },
        sgMarketsUrl: 'https://www-uat.sgmarkets.com',
    },
    [Environment.Production]: {
        ...defaultConfiguration,
        baseApiUrls: {
            legal: 'https://api-z.sgmarkets.com/services/legal/anonymous/private/v1',
        },
        clientId: 'df51f4a8-7433-471d-890f-9688eb56aaff',
        authorizationEndpoint: 'https://sso.sgmarkets.com/sgconnect/oauth2/authorize',
        sgConnectEnvironment: SgConnectEnvironment.Production,
        widgetCdnBaseUrl: 'https://sgwt-cdn-widgets.sgmarkets.com',
        sharedSgMarketsBaseUrl: 'https://shared.sgmarkets.com',
        sgMonitoringRumUrl: 'https://t-monitoring-rum.sgmarkets.com/rum/540a239031b64d7fbe34fe54fef041db',
        sgMarketsUrl: 'https://www.sgmarkets.com',
    },
    [Environment.Test]: {
        ...defaultConfiguration,
    },
};

export const configuration = configurationPerEnvironment[getEnvironment()];
